// ACTION TYPE TEST_CONNEXION_BACK
export const TEST_CONNEXION_BACK = 'TEST_CONNEXION_BACK';
// ACTION CREATOR testConnexionBack
export const testConnexionBack = () => ({
  type: TEST_CONNEXION_BACK,
});

// ACTION TYPE LOGIN_TEST
export const LOGIN_TEST = 'LOGIN_TEST';
// ACTION CREATOR loginTest
export const loginTest = () => ({
  type: LOGIN_TEST,
});

// ACTION TYPE INSCRIPTION_DEV
export const INSCRIPTION_DEV = 'INSCRIPTION_DEV';
// ACTION CREATOR inscriptionDev
export const inscriptionDev = () => ({
  type: INSCRIPTION_DEV,
});

// ACTION TYPE VALIDATE_MODIFY_DEV
export const VALIDATE_MODIFY_DEV = 'VALIDATE_MODIFY_DEV';
// ACTION CREATOR validateModifyDev
export const validateModifyDev = () => ({
  type: VALIDATE_MODIFY_DEV,
});

// ACTION TYPE INSCRIPTION_RECRUITER
export const INSCRIPTION_RECRUITER = 'INSCRIPTION_RECRUITER';
// ACTION CREATOR inscriptionRecruiter
export const inscriptionRecruiter = () => ({
  type: INSCRIPTION_RECRUITER,
});

// ACTION TYPE VALIDATE_MODIFY_RECRUITER
export const VALIDATE_MODIFY_RECRUITER = 'VALIDATE_MODIFY_RECRUITER';
// ACTION CREATOR validateModifyRecruiter
export const validateModifyRecruiter = () => ({
  type: VALIDATE_MODIFY_RECRUITER,
});

// ACTION TYPE SEARCH_CITY
export const SEARCH_CITY = 'SEARCH_CITY';
// ACTION CREATOR searchCity
export const searchCity = () => ({
  type: SEARCH_CITY,
});

// ACTION TYPE FETCH_PROFILE
export const FETCH_PROFILE = 'FETCH_PROFILE';
// ACTION CREATOR fetchProfile
export const fetchProfile = () => ({
  type: FETCH_PROFILE,
});

// ACTION TYPE RECRUITER_FAVORITES
export const RECRUITER_FAVORITES = 'RECRUITER_FAVORITES';
// ACTION CREATOR recruiterFavorites
export const recruiterFavorites = () => ({
  type: RECRUITER_FAVORITES,

});

// ACTION TYPE DELETE_ONE_FAVORITE
export const DELETE_ONE_FAVORITE = 'DELETE_ONE_FAVORITE';
// ACTION CREATOR deleteOneFavorite
export const deleteOneFavorite = () => ({
  type: DELETE_ONE_FAVORITE,

});

// ACTION TYPE ADD_ONE_FAVORITE
export const ADD_ONE_FAVORITE = 'ADD_ONE_FAVORITE';
// ACTION CREATOR searchProfile
export const addOneFavorite = () => ({
  type: ADD_ONE_FAVORITE,

});
